<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <ArticleHomeDetail/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import ArticleHomeDetail from "@/views/business/article/articleHomeDetail.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ArticleHomeDetail,
    Footer
  },
}
</script>

<style>
</style>